import type { CopilotScope } from "@productlane/lib/src/ai"

// The pill only names the entry the copilot already reads as page context, so
// scopes without an on-screen document get none.
export const copilotContextPillLabel = (
	scope: CopilotScope | null | undefined,
	title: string | null | undefined,
): string | null => {
	if (!scope) return null
	if (scope.kind !== "article" && scope.kind !== "changelog") return null
	return title?.trim() || "Untitled"
}

// Only the article and changelog surfaces show a removable context pill, so
// dismissing it is what drops their page context from the next turn.
export const shouldSendPageContext = (
	scope: CopilotScope,
	dismissed: boolean,
): boolean => {
	if (scope.kind === "reporting" || scope.kind === "agent") return true
	if (scope.kind !== "article" && scope.kind !== "changelog") return false
	return !dismissed
}

// The wrapper sits directly under the transcript, so it carries the fill only;
// an outline here draws a hairline across the foot of the scroll area.
export const COPILOT_CONTEXT_WRAPPER_CLASSES =
	"rounded-xl bg-gray-100 dark:bg-gray-800/60"

// The row is a label, not a text field, so it keeps the arrow.
export const COPILOT_CONTEXT_ROW_CLASSES =
	"group/context flex h-8 cursor-default items-center gap-2 pl-2.5 pr-1"
